"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MEDIA_QUERY_BREAKPOINT_SELECTOR: ()=>MEDIA_QUERY_BREAKPOINT_SELECTOR,
    SURFACE_PADDING: ()=>SURFACE_PADDING,
    DIALOG_GAP: ()=>DIALOG_GAP,
    SURFACE_BORDER_WIDTH: ()=>SURFACE_BORDER_WIDTH,
    ACTIONS_START_GRID_AREA: ()=>ACTIONS_START_GRID_AREA,
    ACTIONS_END_GRID_AREA: ()=>ACTIONS_END_GRID_AREA,
    TITLE_GRID_AREA: ()=>TITLE_GRID_AREA,
    TITLE_ACTION_GRID_AREA: ()=>TITLE_ACTION_GRID_AREA,
    CONTENT_GRID_AREA: ()=>CONTENT_GRID_AREA
});
const MEDIA_QUERY_BREAKPOINT_SELECTOR = '@media screen and (max-width: 480px)';
const SURFACE_PADDING = '24px';
const DIALOG_GAP = '8px';
const SURFACE_BORDER_WIDTH = '1px';
const ACTIONS_START_GRID_AREA = 'actions-start';
const ACTIONS_END_GRID_AREA = 'actions-end';
const TITLE_GRID_AREA = 'title';
const TITLE_ACTION_GRID_AREA = 'close-button';
const CONTENT_GRID_AREA = 'body'; //# sourceMappingURL=constants.js.map

//# sourceMappingURL=constants.js.map